import React, { Component, Fragment } from 'react';

import DEFINE, { TOUR_TABS, DETAIL_ACTIONS } from '../../../../../../constants/Define';
import moment from 'moment';
import { getPermissionActions } from '../../../../../../helpers/functions';
import Wrapper from './../../../../common/component/Wrapper';
import Button from './../../../../common/component/Button';
import Switch from './../../../../common/component/Switch';
import Tabs, { TabPane } from './../../../../common/component/Tabs';
import Span from '../../../../common/component/Span';

import DepartureDate from './DepartureDate';
import TourTicket from './TourTicket';
import GeneralInfo from './Generalnfo';
import TripItinerary from './TripItinerary';
import DefaultPrice from './DefaultPrice';
import Note from './Note';
import Images from './Images';

import { Spin } from 'antd';
import { every } from 'lodash';

import './TourTabs.less';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';

const TABS = TOUR_TABS;
let permissionTicketActions = [];
export default class TourTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadFiles: [],
            activeTab: this.props.activeTab,
            activeTourInfoTab: TABS.TOUR_INFO.GENERAL_INFO.id,
        };
    }

    componentDidMount() {
        permissionTicketActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TOUR_TICKETS);
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeTab !== prevProps.activeTab) {
            this.setState({ activeTab: this.props.activeTab })
        }
    }

    render() {
        const { action } = this.props;
        const isDisabledDepartureTab = action === DETAIL_ACTIONS.CREATE || action === DETAIL_ACTIONS.TRANSLATE;
        const isDisableTicketTab = action === DETAIL_ACTIONS.CREATE || action === DETAIL_ACTIONS.TRANSLATE;
        return (
            <Wrapper className='col-md-12 tour-tabs'>
                <Tabs type="card" tabBarExtraContent={this.renderTabButton()}
                    activeKey={this.state.activeTab}
                    onChange={this.onChangeActiveTab}>
                    {this.getTabItem(TABS.TOUR_INFO, this.renderTourInfoTabs())}
                    {permissionTicketActions && permissionTicketActions.allowView && (
                        this.getTabItem(TABS.TOUR_TICKET, this.renderTourTicketTabs(), 'tour-ticket-tab', isDisableTicketTab)
                    )}
                    {this.getTabItem(TABS.DEPARTURE_DATE, this.renderDepartureDateTab(), 'departure-date-tab', isDisabledDepartureTab)}
                </Tabs>
            </Wrapper>
        )
    }

    renderTourInfoTabs() {
        const className = 'tour-info-tabs';
        const { tour, onChangeDetail, action } = this.props;

        return (
            <>
                <Tabs activeKey={this.state.activeTourInfoTab}
                    onChange={activeTourInfoTab => this.setState({ activeTourInfoTab })}>
                    {this.getTabItem(TABS.TOUR_INFO.GENERAL_INFO, this.renderGeneralInfoTab(), className)}
                    {/* {this.getTabItem(TABS.TOUR_INFO.TRIP_ITINERARY, this.renderTripItineraryTab(), className)} */}
                    {this.getTabItem(TABS.TOUR_INFO.DEFAULT_PRICE, this.renderDefaultPriceTab(), className, this.props.action === DETAIL_ACTIONS.TRANSLATE)}
                    {/* {this.getTabItem(TABS.TOUR_INFO.NOTED, this.renderNoteTab(), className)} */}
                    {this.getTabItem(TABS.TOUR_INFO.IMAGES, this.renderImagesTab(), className)}
                </Tabs>
                {action === DETAIL_ACTIONS.UPDATE && (
                    <AutoTranslate
                        languageCode={tour?.languageCode || 'vi-VN'}
                        onChange={onChangeDetail}
                        targetLanguage={tour?.targetLanguage}
                    />
                )}
            </>
        )
    }

    renderTourTicketTabs() {
        const { tour, validation, action, visibleBtnUpdate, tourTicketData, loading } = this.props;
        return (
            <TourTicket tour={tour} action={action}
                loading={loading}
                tourTicketData={tourTicketData}
                validation={validation}
                onChange={this.props.onChangeTicket}
                onCreate={(tourLine) => this.props.onCreateTourLine(false, tourLine)}
                onSave={this.props.onSaveTourLine}
                onInitTickets={this.props.onInitTickets}
                onRemove={this.props.onRemoveTourLine}
                getDetailTourTicket={this.props.getDetailTourTicket}
                allowUpdate={!visibleBtnUpdate}
            />
        )
    }

    renderTabButton() {
        const { t, tour, loading, action, saveDisabled, visibleBtnUpdate } = this.props;
        return (
            <Fragment>
                {/* {action !== DETAIL_ACTIONS.TRANSLATE &&
                    <Switch className="mr-4 active-switch" defaultChecked={tour.isEnabled}
                        label={tour.isEnabled ? t(`item.tour.active`) : t(`item.tour.deactive`)}
                        onChange={(checked) => this.props.onChangeDetail && this.props.onChangeDetail('isEnabled', checked)} />
                } */}
                <Button className="btn btn-dark btn-back" icon={action === DETAIL_ACTIONS.TRANSLATE ? 'close' : "left"}
                    onClick={this.props.onClickBack}
                    htmlType={`button`}>
                    {action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t('action.back')}
                </Button>
                {!visibleBtnUpdate &&
                    <Button disabled={saveDisabled} className="btn btn-primary ml-2 btn-save" icon={action === DETAIL_ACTIONS.CREATE ? 'plus' : "save"} loading={loading}
                        htmlType={`submit`}>
                        {action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : (action === DETAIL_ACTIONS.CREATE ? t('action.create') : t('action.update'))}
                    </Button>
                }
            </Fragment>
        )
    }

    getTabItem = (tabEnum, content, className, idDisabled) => {
        const { t, validation, loading } = this.props;
        const { activeTab, activeTourInfoTab } = this.state;
        const passedValidate = tabEnum.validateFields ? every(tabEnum.validateFields, (f) => !validation[f]) : true;
        const isCurrentTab = activeTab === tabEnum.id || activeTourInfoTab === tabEnum.id;
        const hadLoadingElm = tabEnum.id === TABS.TOUR_INFO.id || tabEnum.id === TABS.DEPARTURE_DATE.id;
        return (
            <TabPane disabled={idDisabled} tab={!passedValidate && !isCurrentTab
                ? (<Span className="pl-2 colorRed">{t(`item.tour.${tabEnum.key || tabEnum.id}`)}*</Span>)
                : <Span className="pl-2 pr-2">{t(`item.tour.${tabEnum.key || tabEnum.id}`)}</Span>
            } key={tabEnum.id}>
                <Wrapper className={`tour-tab-content ${className || ''}`}>
                    {content}
                    {hadLoadingElm && loading && <Wrapper className="loading"><Spin /></Wrapper>}
                </Wrapper>
            </TabPane>
        )
    }

    renderDepartureDateTab() {
        const { tour, validation, action, tourLines, tourLineDateRange, tourLineDateRanges, isShowBulkCreate, visibleBtnUpdate, loading } = this.props;
        return (
            <DepartureDate tour={tour} action={action}
                dateRanges={tourLineDateRanges}
                dateRange={tourLineDateRange}
                tourLines={tourLines}
                isShowBulkCreate={isShowBulkCreate}
                showBulkCreate={this.props.showBulkCreate}
                validation={validation}
                onChange={this.props.onChangeDeparture}
                onChangeDateRange={this.props.onChangeTourLineDateRange}
                onChangeTourTicketFilter={this.props.onChangeTourLineTicketFilter}
                onCreate={(tourLine) => this.props.onCreateTourLine(false, tourLine)}
                onSave={this.props.onSaveTourLine}
                onInitTickets={this.props.onInitTickets}
                onRemove={this.props.onRemoveTourLine}
                onBulkCreate={(data) => this.props.onCreateTourLine(true, data)}
                onBulkUpdate={this.props.onBulkUpdateTourLines}
                onBulkDelete={this.props.onBulkDeleteTourLines}
                getItemTicket={this.props.getItemTicket}
                allowUpdate={!visibleBtnUpdate}
                isTour={tour.type === 2 || tour.type === 7}
                loading={loading}
            />
        )
    }

    renderGeneralInfoTab() {
        const { tour, validation, validateTabContent, action, tourTypes, provinces, supplierSelectData, supplierAll, tagsSKUVW } = this.props;
        return (
            <GeneralInfo tour={tour}
                action={action}
                validation={validation}
                validateTabContent={validateTabContent}
                tourTypes={tourTypes}
                tagsSKUVW={tagsSKUVW}
                departures={provinces}
                destinations={provinces}
                supplierSelectData={supplierSelectData}
                supplierAll={supplierAll}
                onChange={this.props.onChangeDetail}
                onCreateTourType={this.props.onCreateTourType}
                onUpdateTourType={this.props.onUpdateTourType}
                onDeleteTourType={this.props.onDeleteTourType}
                onCreateTagSKUVW={this.props.onCreateTagSKUVW}
                onUpdateTagSKUVW={this.props.onUpdateTagSKUVW}
                onDeleteTagSKUVW={this.props.onDeleteTagSKUVW}
                listProperties={this.props.listProperties}
                onChangeMemberShip={this.props.onChangeMemberShip}
                //tags
                _tagSKUs={this.props._tagSKUs}
                tagGroupDetailState={this.props.tagGroupDetailState}
                _loadDataTagGroup={this.props._loadDataTagGroup}
                _onAddTagGroup={this.props._onAddTagGroup}
            />
        )
    }

    renderTripItineraryTab() {
        const { tour, validation } = this.props;
        return (
            <TripItinerary tour={tour} validation={validation} onChange={this.props.onChangeDetail} />
        )
    }

    renderDefaultPriceTab() {
        const { tour, validation } = this.props;
        return (
            <DefaultPrice tour={tour} validation={validation} onChange={this.props.onChangeDetail} />
        )
    }

    renderNoteTab() {
        const { tour, validation } = this.props;
        return (
            <Note tour={tour} validation={validation} onChange={this.props.onChangeDetail} />
        )
    }

    renderImagesTab() {
        const { tour, validation, action } = this.props;
        return (
            <Images tour={tour} validation={validation}
                action={action}
                uploadingField={this.props.uploadingField}
                onChange={this.props.onChangeDetail}
                onUploadImage={this.props.onUploadImage}
                onRemoveImage={this.props.onRemoveImage}
                onChangeOrderSlide={this.props.onChangeOrderSlide}
            />
        )
    }

    onChangeActiveTab = activeTab => {
        this.setState({ activeTab });
        return this.props.onChangeActiveTab(activeTab)
    }

}

TourTabs.defaultProps = {
    activeTab: TABS.TOUR_INFO.id,
    onChangeDetail: (field, value) => { },
    onChangeDeparture: (tourLineIndex, fieldName, value) => { },
    onChangeActiveTab: (activeTab) => { },
    onChangeTourLineDateRange: (dateRange) => { },
    onChangeTourLineTicketFilter: (tourTicketId) => { },
    onCreateTourLine: (isBulk, dateTabSelect) => { },
    onSaveTourLine: (tourLine, index) => { },
    onRemoveTourLine: (tourLine, index) => { },
    onBulkUpdateTourLines: (tourLineBulk) => { },
    onBulkDeleteTourLines: (tourLines) => { },
    onCreateTourType: type => { },
    onUpdateTourType: type => { },
    onDeleteTourType: type => { },
    tourLineDateRange: [moment().startOf('month').add(1, 'days'), moment('03-2020', 'MM-YYYY').endOf('month')],
    saveDisabled: false,
    visibleBtnUpdate: false
}
